import { AccurateDateIntervalWithShift } from '@wilson/interfaces';
import { isBefore } from 'date-fns';

export function cloneAndSortShiftViewsByStartDatetime(
  shiftViews: AccurateDateIntervalWithShift[],
): AccurateDateIntervalWithShift[] {
  const clonedViewViews = [...shiftViews];
  return clonedViewViews.sort((shiftViewA, shiftViewB) => {
    return isBefore(
      new Date(shiftViewB.accurateStartDateTime),
      new Date(shiftViewA.accurateStartDateTime),
    )
      ? 1
      : -1;
  });
}
